var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 175",
    x: 2.35742,
    y: 0.880981,
    width: 24.4444,
    height: 2.22222,
    transform: "rotate(45 2.35742 0.880981)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 176",
    x: 19.6426,
    y: 2.45227,
    width: 24.4444,
    height: 2.22222,
    transform: "rotate(135 19.6426 2.45227)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cc3420b1cf2b3c49091698d5f4445b1a.svg";
export { ForwardRef as ReactComponent };